import React from 'react'
import ReactDOM from 'react-dom'
import { Upload, Form, Icon, Input, Button, Row, Col, DatePicker } from 'antd'

export const ConsentFormStep3aSurrogate = (props) => {



    if ( (props.currentStep !== 'Step 3a') || (props.consentPersonType !== 'Surrogate') || (props.consentMethodType !== 'Electronic') ) {
      return null
    }
    return(
      <div className="form-group">


            <h3 style={{ display: 'inline-block !important' }}>Electronic Consent Process - Surrogate</h3>

            <h4 style={{ display: 'inline-block !important' }}>Site ID: <span style={{ color: '#4CDEF5', display: 'inline-block' }}>{props.siteID}</span></h4>
            <h4 style={{  display: 'inline-block !important' }}>User ID: <span style={{ color: '#4CDEF5', display: 'inline-block' }}>{props.userID}</span></h4>
            <h4 style={{  display: 'inline-block !important' }}>Subject ID: <span style={{ color: '#4CDEF5', display: 'inline-block' }}>{props.subjectID}</span></h4>

            {props.has_randomization_platform_step_3_surrogate ? <div dangerouslySetInnerHTML={{__html: props.randomization_platform_step_3_surrogate_content}} /> :
            <div>
                <p>Form not loaded.</p>
            </div>
            }

            <p><strong>Server Date (UTC): {props.date || props.consentDate}</strong></p>
            <p><strong>Consent Type: {props.consentPersonType}</strong></p>
            <p><strong>Consent Method: {props.consentMethodType}</strong></p>
            <p>&nbsp;</p>

            <Form.Item>
                {props.getFieldDecorator('fullName', {
                    initialValue: props.fullName,
                    onChange: props.handleChange,
                    rules: [{
                        required: true,
                        message: 'Please enter the Participant\'s full name'
                    }],
                })(
                    <Input
                        prefix={<Icon type="user" style={{color: '#FAFAFA'}}/>}
                        id="fullName"
                        name="fullName"
                        placeholder="Participant Full Name"
                        autoFocus
                        allowClear
                        size="large"
                    />
                )}
            </Form.Item>

            <Form.Item>
                {props.getFieldDecorator('dateOfBirth', {
                    initialValue: props.dateOfBirth,
                    onChange: props.handleDatePickerChange,
                    rules: [{
                        required: false,
                        message: 'Please select the Participant\'s Date of Birth'
                    }],
                })(
                    <DatePicker
                        prefix={<Icon type="user" style={{color: '#FAFAFA'}}/>}
                        id="dateOfBirth"
                        name="dateOfBirth"
                        placeholder="Participant Date of Birth (optional)"
                        allowClear
                        size="large"
                        className="ant-input ant-input-lg"
                    />
                )}
            </Form.Item>


            <Form.Item>
                {props.getFieldDecorator('representativeFullName', {
                    initialValue: props.representativeFullName,
                    onChange: props.handleChange,
                    rules: [{
                        required: true,
                        message: 'Please enter the Legally Authorized Representative\'s full name'
                    }],
                })(
                    <Input
                        prefix={<Icon type="user" style={{color: '#FAFAFA'}}/>}
                        id="representativeFullName"
                        name="representativeFullName"
                        placeholder="Representative's Full Name"
                        allowClear
                        size="large"
                    />
                )}
            </Form.Item>


            <Form.Item>
                {props.getFieldDecorator('witnessFullName', {
                    initialValue: props.witnessFullName,
                    onChange: props.handleChange
                })(
                    <Input
                        prefix={<Icon type="user" style={{color: '#FAFAFA'}}/>}
                        id="witnessFullName"
                        name="witnessFullName"
                        placeholder="Witness Full Name"
                        allowClear
                        size="large"
                    />
                )}
            </Form.Item>


            <Form.Item>
                {props.getFieldDecorator('investigatorFullName', {
                    initialValue: props.investigatorFullName,
                    onChange: props.handleChange,
                    rules: [{
                        required: true,
                        message: 'Please enter the Investigator/Delegate\'s full name'
                    }],
                })(
                    <Input
                        prefix={<Icon type="user" style={{color: '#FAFAFA'}}/>}
                        id="investigatorFullName"
                        name="investigatorFullName"
                        placeholder="Investigator/Delegate Full Name"
                        allowClear
                        size="large"
                    />
                )}
            </Form.Item>

            <Form.Item>
                {props.getFieldDecorator('consentOption', {
                    initialValue: props.consentOption,
                    onChange: props.handleChange,
                    rules: [{
                        required: true,
                        message: 'Please select consent option below:'
                    }],
                })(
                  <label>
                    <h5>
                    Please select consent option below:
                    </h5>
                      <select id="consentOption" name="consentOption" size="large" className="ant-input ant-input-lg">
                        <option value="">Consent Option?</option>
                        <option value="stay_in_study">I wish to stay in the study</option>
                        <option value="withdraw_from_study">I wish to withdraw from the study</option>
                        <option value="withdraw_from_study_allow_data_collection_via_linkage">I wish to withdraw from the study but allow my data to be collected from this point onward via health record linkage</option>
                      </select>
                  </label>
                )}
            </Form.Item>

            <Form.Item>
                {props.getFieldDecorator('consentProvided', {
                    initialValue: props.consentProvided,
                    onChange: props.handleChange,
                    rules: [{
                        required: true,
                        message: 'Do you consent to the terms described above?'
                    }],
                })(
                  <label>
                    <h5>
                    Do you consent to the terms described above? If no, please click on the Back button!
                    </h5>
                      <select id="consentProvided" name="consentProvided" size="large" className="ant-input ant-input-lg">
                        <option value="">Provide Consent?</option>
                        <option value="yes">Yes</option>
                        <option value="">No</option>
                      </select>
                  </label>
                )}
            </Form.Item>

      </div>
    );
}



// WEBPACK FOOTER //
// ./src/components/ConsentTypeRedDeerCalgary/Step3aSurrogate.js